/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetHeaderModel,
  IGetHeaderRequest,
  IMappers,
  IGetHeaderResponse,
  IGetHeaderResponseError,
  TGetHeaderResponse,
} from './types';

const defaultConfig: TGetHeaderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'header',
  pathApi: '/v1/get-header/',
  hostType: 'api',
} as TGetHeaderModel;

function createGetHeaderModel(parameters: IGetHeaderRequest): TGetHeaderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetHeaderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetHeaderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetHeader<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetHeaderOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetHeaderResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetHeaderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetHeaderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetHeaderResponseError);
    }
  }

  return { response, statusCode } as TGetHeaderResponse;
}

export { defaultConfig, createGetHeaderModel, fetchGetHeader };
